const o = "_root_13i5h_1", t = "_info_13i5h_11", c = "_compact_13i5h_15", _ = "_standard_13i5h_18", n = "_comfort_13i5h_21", a = {
  root: o,
  info: t,
  compact: c,
  standard: _,
  comfort: n
};
export {
  n as comfort,
  c as compact,
  a as default,
  t as info,
  o as root,
  _ as standard
};
//# sourceMappingURL=index.es5651.js.map
